import React, {MouseEvent, useEffect, useMemo, useState} from "react";
import Grid from "@mui/material/Grid";
import BasicTable from "../../components/tables/BasicTable";
import {ColumnDef, ColumnFiltersState} from "@tanstack/react-table";
import {useAppDispatch, useAppSelector} from "../../reducers/hooks";
import {Edit, Trash} from "iconsax-react";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import {deleteElement, getAllElement, UserElement} from "../../reducers/User/UserReducer";
import {Typography} from "@mui/material";
import AlertExampleElementDelete from "../../sections/modals/exampleElementModal/AlertExampleElementDelete";
import ElementModalGeneric from "sections/modals/exampleElementModal/ElementModalGeneric";
import {FormattedMessage, useIntl} from "react-intl";
import {openSnackbar, SnackbarState} from "reducers/snackbar/snackbarReducer";
import {UserElementForm} from "../../sections/forms/User/UserElementForm";

export default function User() {
    const dispatch = useAppDispatch();
    const intl = useIntl()

    const [open, setOpen] = useState<boolean>(false);
    const {elements, currentPage, totalRows, sort} = useAppSelector(state => state.userElement);
    const [selectedElement, setSelectedElement] = useState<UserElement | null>(null);
    const [selectedDeleteElement, setSelectedDeleteElement] = useState<any>();
    const [deleteAlertOpen, setDeleteAlertOpen] = useState<boolean>(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [filters, setFilters] = useState<ColumnFiltersState | null>([])
    const [showPassword, setShowPassword] = useState(false);


    // Stati di ricerca per ogni colonna
    /*  const [searchTerms, setSearchTerms] = useState({
          username: "",
          email: "",
          tenantId: "",
          enabled:"",
          roles: "",
          businessName: ""
      });

      // Filtrare i dati in base ai termini di ricerca
      const filteredData = Array.isArray(elements)
          ? elements.filter((element: UserElement) => {
              return (
                  (element.username?.toLowerCase() || "").includes(searchTerms.username.toLowerCase()) &&
                  // (element.tenantId?.toLowerCase() || "").includes(searchTerms.tenantId.toLowerCase()) &&
                  (element.email?.toLowerCase() || "").includes(searchTerms.email.toLowerCase()) &&
                  (element.tenantId?.businessName?.toLowerCase() || "").includes(searchTerms.businessName.toLowerCase())

              );
          })
          : [];

  */

    const columns = useMemo<ColumnDef<UserElement>[]>(() => [
        {
            header: intl.formatMessage({id: "Username"}),
            accessorKey: 'username',
            enableColumnFilter: true,

        },
        {
            header: intl.formatMessage({id: "email"}),
            accessorKey: 'email',
            enableColumnFilter: false,

        },
        {
            header: intl.formatMessage({id: "businessName"}),
            accessorKey: 'tenantId.target.businessName',
            enableColumnFilter: false
        },
        {
            header: intl.formatMessage({id: "enabled"}),
            accessorKey: 'enabled',
            enableColumnFilter: false,
            disableSortBy: true,
            cell: ({row}) => {
                return (
                    <Stack direction="row" alignItems="center" justifyContent="center" spacing={0}>
                        <Typography>{row.original.enabled ? "Attivo" : "Disattivo"}</Typography>
                    </Stack>
                );
            }
        },
        {
            header: intl.formatMessage({id: "roles"}),
            accessorKey: 'roles',
            enableColumnFilter: false,

        },
        {
            header: () => <FormattedMessage id="Actions" defaultMessage="Actions"/>,
            accessorKey: 'Actions',
            enableColumnFilter: false,
            meta: {
                className: 'cell-right',
            },
            disableSortBy: true,
            cell: ({row}) => {
                // Controlla se la mail è "superAdmim@gmail.com"
                if (row.original.username !== "superAdmin@test.it") {
                    return (
                        <Stack direction="row" alignItems="center" justifyContent="center" spacing={0}>
                            <Tooltip title={<FormattedMessage id="edit" defaultMessage="edit"/>}>
                                <IconButton
                                    color="primary"
                                    onClick={(e: MouseEvent<HTMLButtonElement>) => {
                                        e.stopPropagation();
                                        setSelectedElement(row.original)
                                        setOpen(true)
                                    }}
                                >
                                    <Edit/>
                                </IconButton>
                            </Tooltip>
                            <Tooltip title={<FormattedMessage id="Delete" defaultMessage="Delete"/>}>
                                <IconButton
                                    color="error"
                                    onClick={(e: MouseEvent<HTMLButtonElement>) => {
                                        e.stopPropagation();
                                        setSelectedDeleteElement(row.original)
                                        setDeleteAlertOpen(true)
                                    }}
                                >
                                    <Trash/>
                                </IconButton>
                            </Tooltip>
                        </Stack>
                    );
                }
            }
        }
    ], [intl]);

    useEffect(() => {
        dispatch(getAllElement({
            pageableDto: {page: page, size: rowsPerPage, sort: ['dateCreated', 'asc']},
            filters: filters
        }));
    }, [page, rowsPerPage, JSON.stringify(filters)]);

    /*   const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
           setRowsPerPage(parseInt(event.target.value, 10));
           setPage(0); // Resetta alla prima pagina
       };

       const handleChangePage = (event: MouseEvent<HTMLButtonElement> | null, newPage: number) => {
           setPage(newPage);
       };
   */
    const handleModalOpen = (isOpen: boolean) => {
        setOpen(isOpen);
        if (!isOpen) setSelectedElement(null);
    };
    const columnFiltersState = (values: ColumnFiltersState) => {
        setPage(0)
        setFilters(values)
    };

    const refreshData = () => {
        dispatch(getAllElement({
            pageableDto: {
                page: page,
                size: rowsPerPage,
                sort: ['dateCreated', 'desc']
            },
            filters: filters
        }));
        openSnackbar({
            open: true,
            message: intl.formatMessage({id: 'User added complete'}),
            variant: 'alert',
            alert: {
                color: 'success'
            }
        } as SnackbarState);
    };


    const onDeleteSuccess = () => {
        //effettuare la dispatch della getAll e della visualizzazione popup
        dispatch(getAllElement({
            pageableDto: {page: page, size: rowsPerPage, sort: ['dateCreated', 'asc']},
            filters: filters
        }));
        openSnackbar(
            {
                open: true,
                message: 'Element deleted successfully',
                variant: 'alert',
                alert: {
                    color: 'success'
                }
            } as SnackbarState
        )
    };

    const handleDelete = (_id: string) => {
        dispatch(deleteElement({id: _id, callback: onDeleteSuccess}));
    };
    const {formatMessage} = useIntl();
    const getTableTitle = () => {
        return formatMessage({id: "UserTitle", defaultMessage: "User"});
    };

    return (
        <Grid container>
            <Grid item xs={12}>
                <BasicTable
                    columns={columns}
                    data={elements}
                    title={getTableTitle()}
                    striped
                    modalToggler={() => handleModalOpen(!open)}
                    onFilterChange={columnFiltersState}
                    manualFiltering={true}
                />

                <ElementModalGeneric
                    open={open}
                    setOpen={handleModalOpen}
                    element={selectedElement}
                    onSuccess={refreshData}
                    pageableData={{
                        page,
                        rowsPerPage,
                        filters
                    }}
                    FormComponent={UserElementForm}
                />
                {selectedDeleteElement && (
                    <AlertExampleElementDelete
                        id={selectedDeleteElement._id}
                        title={selectedDeleteElement.username || ""}
                        open={deleteAlertOpen}
                        handleClose={() => setDeleteAlertOpen(false)}
                        onDelete={(id) => handleDelete(id)}
                    />
                )}
            </Grid>
        </Grid>
    );
}